import { defaultTo } from 'lodash';
import { IModel, Model, ModelRecord } from './Model';

export interface IEntityMappingModel extends IModel {
  entityMappingId: number;
  entityMappingTypeId: number;
  entityId: number;
  sourceSystemId: number;
  sourceSystemName: string;
  sourceSystemKey: string;
  dateCreated: string;
  sourceSystemDocumentViewerUrl: string;
}

export class EntityMappingModel
  extends Model
  implements ModelRecord<IEntityMappingModel>
{
  entityMappingId: number;
  entityMappingTypeId: number;
  entityId: number;
  sourceSystemId: number;
  sourceSystemName: string;
  sourceSystemKey: string;
  dateCreated: string;
  sourceSystemDocumentViewerUrl: string;

  constructor(params?: Partial<IEntityMappingModel>) {
    super(params);
    this.entityMappingId = defaultTo(params?.entityMappingId, 0);
    this.entityMappingTypeId = defaultTo(params?.entityMappingTypeId, 0);
    this.entityId = defaultTo(params?.entityId, 0);
    this.sourceSystemId = defaultTo(params?.sourceSystemId, 0);
    this.sourceSystemName = defaultTo(params?.sourceSystemName, '');
    this.sourceSystemKey = defaultTo(params?.sourceSystemKey, '');
    this.dateCreated = defaultTo(params?.dateCreated, '');
    this.sourceSystemDocumentViewerUrl = defaultTo(
      params?.sourceSystemDocumentViewerUrl,
      '',
    );
  }
}
